import { constants, locale } from '..';

const { API_ERROR_MESSAGES } = constants;

/**
 * Check for error messages with special semantic meaning and return only one of them if found. If
 * no special errors are found, return a generic error.
 * @param {Error[]} errors
 * @return {Error}
 */
export const getAddStatementError = (errors: Error[]): Error => {
    const errorMessages = errors.reduce(
        (acc: string[], error: Error): string[] => {
            if (error.message) {
                acc.push(error.message);
            }

            return acc;
        },
        [] as string[],
    );

    // 1. This is not a valid statement
    if (errorMessages.includes(API_ERROR_MESSAGES.NOT_A_VALID_STATEMENT)) {
        return new Error(API_ERROR_MESSAGES.NOT_A_VALID_STATEMENT);
    }

    // 2. This is a duplicate statement
    if (errorMessages.includes(API_ERROR_MESSAGES.STATEMENT_PREVIOUSLY_ADDED)) {
        return new Error(API_ERROR_MESSAGES.STATEMENT_PREVIOUSLY_ADDED);
    }

    // This is not a special error; return a generic error instead
    return new Error(locale.enUS.INGESTION.ERRORS.ADD_STATEMENT_ERROR);
};
